/*==============================
=            Common            =
==============================*/

// check if mobile device so can use more native functions
var IS_MOBILE = ( navigator.userAgent.match(/Android/i) ||
                  navigator.userAgent.match(/webOS/i) ||
                  navigator.userAgent.match(/iPhone/i) ||
                  navigator.userAgent.match(/iPod/i) ||
                  navigator.userAgent.match(/BlackBerry/i) ||
                  navigator.userAgent.match(/Windows Phone/i) ||
                  navigator.userAgent.match(/iPad/i) );
var click = 'click';
if( IS_MOBILE ) {
  click = 'touchend';
}

export function debounce(func, wait = 20, immediate = true) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

if (!Array.prototype.forEach) {
  Array.prototype.forEach = function(fn, scope) {
    for(var i = 0, len = this.length; i < len; ++i) {
      fn.call(scope, this[i], i, this);
    }
  }
}

/*=====  End of Common  ======*/
